import { EntityType } from "@mapmycustomers/shared/enum";
import { Person } from "@mapmycustomers/shared/types/entity";
import { RoutePersonStop } from "@mapmycustomers/shared/types/entity/Route";

import toRouteEntityAddress from "./toRouteEntityAddress";

/**
 * Builds a draft (unsaved) RoutePersonStop from a Person entity. Sibling of
 * companyEntityToRouteStop — see that file for the draft-id convention. The
 * `contact` projection mirrors the v2 detail/bulk-stops response shape.
 */
const personEntityToRouteStop = (
  entity: Person,
  displayOrder: number,
  allottedTime: number
): Omit<RoutePersonStop, "createdAt" | "id" | "updatedAt"> => ({
  allottedTime,
  checkedOff: false,
  contact: {
    ...toRouteEntityAddress(entity),
    id: entity.id,
    geoPoint: entity.geoPoint,
    name: entity.name,
  },
  contactId: entity.id,
  displayOrder,
  entity: EntityType.PERSON,
});

export default personEntityToRouteStop;
